import type { IDocumentReaderUploadReference } from '@commenda/api/commenda-ai/document-reader/types';
import { Icons } from '@commenda/kakashi';

import { DataRoomUploadHelper } from './DataRoomUploadHelper';

interface DataRoomUploadPillProps {
  dataRoom: IDocumentReaderUploadReference;
}

/** The data room a chat message refers to, drawn from its stored `data-document-upload` part. */
export const DataRoomUploadPill = ({ dataRoom }: DataRoomUploadPillProps) => (
  <div className="mt-md inline-flex items-center gap-sm rounded-full border border-border-tertiary bg-bg-secondary px-md py-xs">
    <Icons.Archive
      className="size-4 shrink-0 text-fg-secondary"
      aria-hidden="true"
    />
    <span className="txt-extra-small-medium text-text-secondary">
      {`Data room: ${dataRoom.fileCount} ${dataRoom.fileCount === 1 ? 'file' : 'files'}, ${DataRoomUploadHelper.formatBytes(dataRoom.totalSizeBytes)}`}
    </span>
  </div>
);
